export const SAVED_FILTERS_API_BASE_URL = '/api/data-alert/criteria';
